import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { isEqalDate, isInInterval } from "./date";
export var getNewRangeValidValue = function getNewRangeValidValue(date, value, minDate, maxDate) {
  var disableDates = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var _value = _slicedToArray(value, 2),
    startDate = _value[0],
    endDate = _value[1];
  if (!isInInterval(date, minDate, maxDate)) {
    return value;
  }
  if (startDate && !isInInterval(startDate, minDate, maxDate) || endDate && !isInInterval(endDate, minDate, maxDate)) {
    return [date, null];
  }
  if (disableDates.length) {
    var includes = disableDates.find(function (el) {
      return Array.isArray(el) ? isInInterval(date, el[0], el[1]) : isEqalDate(el, date);
    });
    if (includes) {
      return value;
    }
  }
  if (startDate && isEqalDate(startDate, date)) {
    return [endDate, null];
  }
  if (endDate && isEqalDate(endDate, date)) {
    return [startDate, null];
  }
  if (startDate && !endDate) {
    var range = startDate > date ? [date, startDate] : [startDate, date];
    var hasIncludes = !!disableDates.find(function (el) {
      return Array.isArray(el) ? isInInterval(el[0], range[0], range[1]) || isInInterval(el[1], range[0], range[1]) : isInInterval(el, range[0], range[1]);
    });
    return hasIncludes ? [date, null] : range;
  }
  return [date, null];
};